import dayjs from 'dayjs'
interface ICalendarOptions {
  daysLabel: string[] // Labels for days in title, start by sunday
  monthsLabel: string[] // labels for months in title, start by january
  limit: number // max nb meetings to display on a same column
  spacing: number // When clicking next, how many cells do you want to scroll
  loadingLabel: string // label to display when loading
  disabledDate: Function // function to disable left button (date is passed as params)
}
export const meetingSlotsOptions = (spacing: number): ICalendarOptions => ({
  daysLabel: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  monthsLabel: [
    'Jan',
    'Fév',
    'Mar',
    'Avr',
    'Mai',
    'Juin',
    'Juil',
    'Aoû',
    'Sep',
    'Oct',
    'Nov',
    'Déc',
  ],
  limit: 5,
  spacing: spacing,
  loadingLabel: 'Chargement...',
  disabledDate: (date: Date) => {
    const today = dayjs(new Date()).format('YYYY-MM-DD')
    const selectedDate = dayjs(date).format('YYYY-MM-DD')
    return selectedDate <= today
  },
})
